import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Settings, Search, Wrench } from 'lucide-react';
import imagen1 from '../assets/images/ServicesPage/servicepageimg1.webp';
import imagen2 from '../assets/images/ServicesPage/servicepageimg2.webp';
import imagen3 from '../assets/images/ServicesPage/servicepageimg3.webp';
import imagenwidget1 from '../assets/images/ServicesPage/imagenwidget1.webp';
import imagenwidget2 from '../assets/images/ServicesPage/imagenwidget2.webp';
import imagenwidget3 from '../assets/images/ServicesPage/imagenwidget3.webp';

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

const ServicesPage = ({ service = 'main' }) => {
  const engineeringNumbers = [
    { name: "Ing. Alex Castillo", phone: "+57 (318) 347 3820", specialty: "SEP y Materiales." },
    { name: "Ing. Lousiana Rojas", phone: "+57 (302) 406 1718", specialty: "Certificaciones y Laboratorios." },
    { name: "Ing. Samuel Ramos", phone: "+57 (317) 636 4592", specialty: "Producción, Garantías y Mantenimiento." }
  ];

  const images = [imagen1, imagen2, imagen3];
  const [currentIndex, setCurrentIndex] = useState(0);
  const particles = Array.from({ length: 25 });

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 8000); // cambia cada 8s suave

    return () => clearInterval(interval);
  }, []);

  const renderMainServices = () => (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <motion.div
        className="relative rounded-xl overflow-hidden shadow-xl shadow-gray-700 hover:shadow-2xl transition-shadow cursor-pointer group p-8 border border-white/40"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        whileHover={{ y: -10 }}
      >
        {/* ImagenBGwidget1 */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${imagenwidget1})` }}
        />

        {/* OverlayAclarado */}
        <div className="absolute inset-0 bg-white/60 group-hover:bg-white/60 transition-all duration-500" />

        {/* Contenido */}
        <div className="relative z-10">

          <div className="bg-gradient-to-br from-blue-500 to-blue-800 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
            <Settings className="w-8 h-8 text-white" />
          </div>

          <h3 className="text-2xl font-bold text-center mb-4 text-black">
            Mantenimiento
          </h3>

          <p className="text-black text-center mb-6">
            Servicios especializados de mantenimiento para elementos de caucho; reapertura a otras líneas proximamente.
          </p>

          <ul className="space-y-2 text-sm text-black">
            <li>• Mantenimiento de puestas a tierra; Reintegración proximamente.</li>
            <li>• Revisión de equipos dieléctricos.</li>
            <li>• Mantenimiento preventivo; Solo elementos de caucho, reapertura de otras líneas proximamente.</li>
            <li>• Mantenimiento correctivo; Reintegración proximamente.</li>
          </ul>
        </div>
      </motion.div>

      <motion.div
        className="relative rounded-xl overflow-hidden shadow-xl shadow-gray-700 hover:shadow-2xl transition-shadow cursor-pointer group p-8 border border-white/40"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        whileHover={{ y: -10 }}
      >
        {/* ImagenBGwidget2 */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${imagenwidget2})` }}
        />

        {/* OverlayAclarado */}
        <div className="absolute inset-0 bg-white/60 group-hover:bg-white/60 transition-all duration-500" />

        {/* Contenido */}
        <div className="relative z-10">
          
          <div className="bg-gradient-to-br from-gray-500 to-gray-800 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
            <Search className="w-8 h-8 text-white" />
          </div>
          
          <h3 className="text-2xl font-bold text-center mb-4 text-black">Laboratorio</h3>
          
          <p className="text-black text-center mb-6">
            Pruebas y análisis especializados en laboratorio certificado por ONAC.
          
          </p>
          
          <ul className="space-y-2 text-sm text-black">
            <li>• Pruebas de rigidez dieléctrica.</li>
            <li>• Calibración de dispositivos.</li>
            <li>• Certificación de equipos.</li>
          </ul>
        </div>
      </motion.div>

      <motion.div
        className="relative rounded-xl overflow-hidden shadow-xl shadow-gray-700 hover:shadow-2xl transition-shadow cursor-pointer group p-8 border border-white/40"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        whileHover={{ y: -10 }}
      >
        {/* ImagenBGwidget3 */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${imagenwidget3})` }}
        />

        {/* OverlayAclarado */}
        <div className="absolute inset-0 bg-white/60 group-hover:bg-white/60 transition-all duration-500" />

        {/* Contenido */}
        <div className="relative z-10">
          
          <div className="bg-gradient-to-br from-yellow-800 to-yellow-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
            <Phone className="w-8 h-8 text-white" />
          </div>
          
          <h3 className="text-2xl font-bold text-center mb-4 text-black">Asesoramiento</h3>
          
          <p className="text-black text-center mb-6">
            Consultoría técnica especializada con equipo de ingeniería y areá técnica competente.
          </p>
          
          <div className="space-y-3">
            {engineeringNumbers.map((engineer, index) => (
              <div key={index} className="bg-gray-50 p-3 rounded-lg">
                <div className="font-semibold text-sm text-black">{engineer.name}</div>
                <div className="text-blue-800 font-medium text-sm">{engineer.phone}</div>
                <div className="text-xs text-gray-700">{engineer.specialty}</div>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );

  const renderMaintenanceService = () => (
    <div className="max-w-4xl mx-auto">
      <motion.div
        className="bg-white rounded-2xl p-8 shadow-xl shadow-gray-700 hover:shadow-2xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">Servicios de Mantenimiento</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-600">Mantenimiento Preventivo</h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Inspección visual de equipos.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Limpieza especializada.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Lubricación de componentes móviles.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Ajustes y calibraciones.
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-500">Mantenimiento Correctivo</h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                Reparación de pértigas.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                Reemplazo de componentes dieléctricos.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                Restauración de equipos dañados.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                Actualización de sistemas obsoletos.
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 p-6 bg-gradient-to-r from-gray-50 to-gray-400 rounded-xl shadow-xl shadow-gray-700">
          <h3 className="text-xl font-bold mb-4 text-gray-800">Programa de Mantenimiento</h3>
          <p className="text-gray-600 mb-4">
            Ofrecemos planes de mantenimiento personalizados para garantizar el óptimo 
            funcionamiento de tus equipos eléctricos durante todo el año. Por favor, tener
            en cuenta que los mantenimientos citados se ejecutarán de acuerdo a las condiciones
            del proceso y políticas de la empresa.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="text-center p-3 bg-white rounded-lg shadow-lg">
              <div className="text-2xl font-bold text-blue-600">24/7</div>
              <div className="text-sm text-gray-600">Soporte técnico</div>
            </div>
            <div className="text-center p-3 bg-white rounded-lg shadow-lg">
              <div className="text-2xl font-bold text-black-600">48h</div>
              <div className="text-sm text-gray-600">Tiempo de respuesta</div>
            </div>
            <div className="text-center p-3 bg-white rounded-lg shadow-lg">
              <div className="text-2xl font-bold text-green-600">100%</div>
              <div className="text-sm text-gray-600">Garantía en servicios</div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );

  const renderLaboratoryService = () => (
    <div className="max-w-4xl mx-auto">
      <motion.div
        className="bg-white rounded-2xl p-8 shadow-xl shadow-gray-700 hover:shadow-2xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">Servicios de Laboratorio</h2>
        
        <div className="space-y-8">
          <div className="border-l-4 border-blue-500 pl-6">
            <h3 className="text-xl font-bold mb-3 text-blue-600">Pruebas de Rigidez Dieléctrica</h3>
            <p className="text-gray-600 mb-3">
              Evaluamos la capacidad aislante de guantes, mangas, pértigas, botas, mantas, coberturas y tapetes dieléctricos 
              según normas internacionales.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM D120</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM F496</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 60903</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM F709</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 60984</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM F711</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 60855</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 60832</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM F2413</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">EN ISO 20345</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM D1048</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM F479</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM D178</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 61111</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM D1049</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM D1050</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM F478</span>
            </div>
          </div>

          <div className="border-l-4 border-blue-500 pl-6">
            <h3 className="text-xl font-bold mb-3 text-blue-600">Verificación de Funcionamiento</h3>
            <p className="text-gray-600 mb-3">
              Comprobamos el correcto funcionamiento de detectores de tensión, multímetros y pinzas voltiamperimétricas,
              equipos de medición, y equipos de puesta a tierra temporales.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 61243</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 61010-1</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 61010-2-033</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ASTM F855</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEEE 516</span>
            </div>
          </div>

          <div className="border-l-4 border-blue-500 pl-6">
            <h3 className="text-xl font-bold mb-3 text-blue-600">Calibración de Dispositivos</h3>
            <p className="text-gray-600 mb-3">
              Calibramos multímetros, pinzas voltiamperimétricas, megóhmetros, comparadores de fase y otros equipos de medición, 
              torquímetros, y otras herramientas de mano, con trazabilidad a patrones nacionales.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ISO/IEC 17025</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 61557-2</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 61481</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">ISO 6789</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 61557-5</span>
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-800 font-bold text-white px-3 py-1 rounded-full text-sm">IEC 61000-4-30</span>
            </div>
          </div>
        </div>

        <div className="mt-8 bg-gradient-to-r from-gray-50 to-gray-400 p-6 rounded-xl shadow-xl shadow-gray-700">
          <h3 className="text-xl font-bold mb-4 text-gray-800">Certificaciones y Reportes</h3>
          <p className="text-gray-600">
            Todos nuestros ensayos incluyen certificados detallados con resultados, 
            recomendaciones y fecha de próxima verificación. Cumplimos con normativa 
            nacional e internacional para garantizar la validez de nuestros reportes.
          </p>
        </div>
      </motion.div>
    </div>
  );

  const renderConsultingService = () => (
    <div className="max-w-4xl mx-auto">
      <motion.div
        className="bg-white rounded-2xl p-8 shadow-xl shadow-gray-700 hover:shadow-2xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">Asesoramiento Técnico</h2>
        
        <div className="mb-8">
          <p className="text-gray-600 text-center text-lg">
            Nuestro equipo de ingenieros especializados está disponible para brindarte 
            asesoría técnica personalizada en todos tus proyectos eléctricos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {engineeringNumbers.map((engineer, index) => (
            <motion.div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-gray-400 p-6 rounded-xl border border-white shadow-xl shadow-gray-700"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="text-center">
                <h3 className="font-bold text-lg text-gray-800 mb-2">{engineer.name}</h3>
                <p className="text-blue-700 font-semibold mb-2">{engineer.specialty}</p>
                <a 
                  href={`tel:${engineer.phone}`}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-blue-800 text-white px-4 py-2 rounded-lg font-semibold hover:shadow-xl transition-shadow"
                >
                  <Phone className="w-4 h-4" />
                  {engineer.phone}
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-600">Servicios de Consultoría</h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Stock de equipos para licitación.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Análisis de riesgos eléctricos.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Selección de equipos de protección.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Capacitación especializada.
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-500">Soporte Técnico</h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                Soporte remoto 24/7.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                Visitas técnicas especializadas.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                Diagnóstico de aprovisionamiento.
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                Optimización de procesos.
              </li>
            </ul>
          </div>
        </div>
      </motion.div>
    </div>
  );

  return (
    <div className="relative min-h-screen py-12 overflow-hidden">
      {/* SLIFER FADE */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute inset-0">
          {images.map((img, index) => {
            const isActive = index === currentIndex;
            
            return (
              <motion.div
                key={index}
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${img})` }}
                initial={{ opacity: 0, scale: 1.02, filter: "blur(8px)" }}
                animate={
                  isActive
                    ? {
                      opacity: 1,
                      scale: 1,
                      filter: "blur(0px)"
                    }
                    : {
                      opacity: 0,
                      scale: 1.05,
                      filter: "blur(6px)"
                    }
                }
                transition={{
                  duration: 2.5,
                  ease: [0.4, 0, 0.2, 1] // easing crossfade cinematográfico
                }}
              />
            );
          })}
        </div>

        {/* OVERLAY GRADIENTE (SUAVIZADO ARRIBA → ABAJO) */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-black/70 to-black z-10" />
        
        {/* PARTICULAS SUAVES */}
        <div className="absolute inset-0 pointer-events-none z-20">
          {particles.map((_, i) => {
            const size = Math.random() * 10 + 8;
            const left = Math.random() * 100;
            const duration = Math.random() * 5 + 5;
            const delay = Math.random() * 10;
            
            return (
              <motion.div
                key={i}
                className="absolute rounded-full bg-blue-300/80 blur-sm shadow-lg shadow-blue-400/60"
                style={{
                  width: size,
                  height: size,
                  left: `${left}%`,
                  bottom: "-100px"
                }}
                initial={{ y: 0 }}
                animate={{ y: -1200 }} // valor grande fijo
                transition={{
                  duration: duration,
                  repeat: Infinity,
                  ease: "linear",
                  delay: delay
                }}
              />
            );
          })}
        </div>
      </div>    

      <div className="container mx-auto px-4">
        
        {service === 'services' || service === 'main' ? renderMainServices() : null}
        {service === 'maintenance' ? renderMaintenanceService() : null}
        {service === 'laboratory' ? renderLaboratoryService() : null}
        {service === 'consulting' ? renderConsultingService() : null}
      </div>
    </div>
  );
};

export default ServicesPage;

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.